import { gql } from '@apollo/client'

import { SHOP_ADDRESS_FRAGMENT } from './shop/address'
import { SHOP_CHECKOUT_SETTING_FRAGMENT } from './shop/checkoutSetting'
import { SHOP_GIFT_CARD_FRAGMENT } from './shop/giftCard'
import { SHOP_TIP_VARIANT_FRAGMENT } from './shop/tipVariant'

export const SHOP_FRAGMENT = gql`
  fragment Shop on Shop {
    active
    address {
      ...ShopAddress
    }
    appFeePercentage
    checkoutSetting {
      ...ShopCheckoutSetting
    }
    confirmationMessage
    currency
    currencySym
    digitalGiftCard {
      ...ShopGiftCard
    }
    hasDiscountCodes
    id
    isGiftCardAvailable
    isPaymentRequired
    isPaymentsAvailable
    isSpreedlyPaymentsAvailable
    isSquareApplePayAvailable
    isSquarePaymentsAvailable
    isStripePaymentsAvailable
    physicalGiftCard {
      ...ShopGiftCard
    }
    squareApplicationId
    squareLocationId
    tipVariants {
      ...ShopTipVariant
    }
  }
  ${SHOP_ADDRESS_FRAGMENT}
  ${SHOP_CHECKOUT_SETTING_FRAGMENT}
  ${SHOP_GIFT_CARD_FRAGMENT}
  ${SHOP_TIP_VARIANT_FRAGMENT}
`
